import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import LandingPage from './pages/LandingPage.jsx';
import Dashboard from './pages/Dashboard.jsx';
import BunkerModule from './modules/bunker/BunkerModule.jsx';
import RiskModule from './modules/risk/RiskModule.jsx';
import WarRisk from './modules/WarRisk/WarRisk.jsx';
import RoutesModule from './modules/routes/RoutesModule.jsx';
import PulseModule from './modules/pulse/PulseModule.jsx';
import NotFound from './pages/NotFound.jsx';
import SignInPage from './pages/SignInPage.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import TermsOfService from './pages/TermsOfService.jsx';
import ProtectedRoute from './auth/ProtectedRoute.jsx';
import useQualifiedLead from './auth/useQualifiedLead.js';

function AuthAnalytics() {
  useQualifiedLead();
  return null;
}

/* All routes other than / are wrapped in the shared Layout (Navbar + footer). */
function AppShell() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default function App() {
  return (
    <>
      <AuthAnalytics />
      <Routes>
        {/* Public landing — has its own nav and footer */}
        <Route path="/" element={<LandingPage />} />

        {/* App shell — all remaining routes use the shared Layout */}
        <Route element={<AppShell />}>
          {/* Public */}
          <Route path="/pulse"       element={<PulseModule />} />
          <Route path="/sign-in/*"   element={<SignInPage />} />
          <Route path="/privacy"     element={<PrivacyPolicy />} />
          <Route path="/terms"       element={<TermsOfService />} />

          {/* Route Calculator — unprotected on first interaction (soft CTA from landing) */}
          <Route path="/calculator"  element={<RoutesModule />} />

          {/* Protected modules */}
          <Route path="/bunker"      element={<ProtectedRoute><BunkerModule /></ProtectedRoute>} />
          <Route path="/war-risk"    element={<ProtectedRoute><WarRisk /></ProtectedRoute>} />
          <Route path="/routes"      element={<ProtectedRoute><RoutesModule /></ProtectedRoute>} />

          {/* Redirects */}
          <Route path="/risk"        element={<Navigate to="/war-risk"  replace />} />
          <Route path="/dashboard"   element={<Navigate to="/bunker"    replace />} />
          <Route path="/compliance"  element={<Navigate to="/routes"    replace />} />
          <Route path="/brief"       element={<Navigate to="/pulse"     replace />} />
          <Route path="/404"         element={<NotFound />} />
          <Route path="*"            element={<Navigate to="/404"       replace />} />
        </Route>
      </Routes>
    </>
  );
}
